<template>
  <div id="app">
    <bq-header ref="appHeader" />

    <div class="bq-content">
      <router-view></router-view>
    </div>

    <bq-footer ref="appFooter" />
  </div>
</template>

<script>
// import BqHeader from '@/components/newwebsite/Header';
// import BqFooter from '@/components/Footer';
import BqHeader from '@/components/website_v3/Header';
import BqFooter from '@/components/website_v3/Footer';

export default {
  name: 'App',

  components: {
    BqHeader,
    BqFooter,
  },
};
</script>

<style lang="less">
@import './assets/styles/reset.less';
#app,
body {
  width: 100%;
  overflow-x: hidden;
}
.app-content {
  padding-top: 90px;
  color: @textColorDark;
}
</style>
